import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f67f946a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "adminAppPage" }
const _hoisted_2 = { class: "searchBar" }
const _hoisted_3 = { class: "btn" }
const _hoisted_4 = { class: "reviewBtn" }

import { ref, watchEffect } from "vue";
import {
  doAppReviewUsingPost,
  getAppDetailUsingGet,
  listAppByPageUsingPost,
} from "@/api/appController";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import {
  APP_SCORING_STRATEGY_MAP,
  APP_TYPE_MAP,
  REVIEW_STATUS_ENUM,
} from "@/constant/app";
import { IconCaretLeft, IconCaretRight } from "@arco-design/web-vue/es/icon";

// 初始化搜索条件

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminPage',
  setup(__props) {

const initSearchParams = {
  current: 1,
  pageSize: 50,
};
const searchParams = ref<API.AppQueryRequest>({
  ...initSearchParams,
  reviewStatus: REVIEW_STATUS_ENUM.REVIEWING,
});
const doSearch = (value: string) => {
  searchParams.value.searchText = value;
  loadData();
};

let index = 1;
const data = ref<API.AppVO[]>([]);
const cardData = ref<API.AppDetailVO>({});
const reviewData = ref<API.ReviewDTO>({
  reviewMessage: "",
});

const loadData = async () => {
  const res = await listAppByPageUsingPost({
    ...searchParams.value,
  });
  if (res.data.code === 200 && res.data.data?.records) {
    data.value = [];
    let first = true;
    res.data.data.records.forEach((item) => {
      if (first) {
        index = 0;
        handleClickItem(item, index);
        first = false;
      }
      data.value.push(item);
    });
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

const fetchData = () => {
  console.log("fetchData");
};

const handleClickItem = async (item: any, idx: number) => {
  const res = await getAppDetailUsingGet({ appId: item.id });
  if (res.data.code === 200) {
    index = idx;
    cardData.value = res.data.data as any;
  } else {
    message.error("查询数据失败，" + res.data.message);
  }
};

const handlePre = async () => {
  if (index > 0) {
    const preIndex = index - 1;
    handleClickItem(data.value[preIndex], preIndex);
  }
};

const handleNext = async () => {
  if (index < data.value.length - 1) {
    const nextIndex = index + 1;
    handleClickItem(data.value[nextIndex], nextIndex);
  }
};

const handleReviewPass = async (id: any) => {
  const res = await doAppReviewUsingPost({
    ...reviewData.value,
    id,
    reviewStatus: REVIEW_STATUS_ENUM.PASS,
  });
  if (res.data.code === 200) {
    loadData();
    message.success("审核通过成功");
  } else {
    message.error("审核通过失败，" + res.data.message);
  }
};

watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        style: { width: '500px' },
        placeholder: "搜索应用",
        "button-text": "搜索",
        size: "large",
        "search-button": "",
        onSearch: doSearch
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        href: "/oj/question/add"
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加题目")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 5,
          class: "sider"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_list, {
              "max-height": 500,
              onReachBottom: fetchData,
              scrollbar: ""
            }, {
              header: _withCtx(() => [
                _createTextVNode(" 应用列表 ")
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_list_item, {
                    key: index,
                    onClick: ($event: any) => (handleClickItem(item, index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.appName), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          span: 12,
          class: "content"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              class: "card",
              title: cardData.value.appVO?.appName
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)[cardData.value.appVO?.appType]) + " " + _toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[cardData.value.appVO?.scoringStrategy]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(cardData.value.appVO?.appDesc) + " ", 1),
                (cardData.value.questionAndOptionVOList)
                  ? (_openBlock(), _createBlock(_component_a_list, {
                      key: 0,
                      virtualListProps: {
              height: 300,
            },
                      data: cardData.value.questionAndOptionVOList,
                      bordered: false
                    }, {
                      item: _withCtx(({ item, index }) => [
                        (_openBlock(), _createBlock(_component_a_list_item, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_list_item_meta, {
                              title: item.question.questionName
                            }, null, 8, ["title"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.optionList, (option, optionIndex) => {
                              return (_openBlock(), _createElementBlock("div", { key: optionIndex }, _toDisplayString(option.optionKey) + "." + _toDisplayString(option.optionName), 1))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      ]),
                      _: 1
                    }, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handlePre,
                style: { width: 100 }
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(IconCaretLeft))
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: handleNext
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(IconCaretRight))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 5 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, { status: "danger" }, {
                default: _withCtx(() => [
                  _createTextVNode("审核不通过")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleReviewPass(cardData.value.appVO?.id)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("审核通过")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_textarea, {
              placeholder: "输入审核信息",
              "allow-clear": "",
              modelValue: reviewData.value.reviewMessage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reviewData.value.reviewMessage) = $event)),
              "auto-size": true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})